/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Sensor_EcInputs */

const vi_irrigation_sensor_ec = /** @type {(inputs: Irrigation_Sensor_EcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EC`)
};

/**

* @param {Irrigation_Sensor_EcInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensor_ec = /** @type {((inputs?: Irrigation_Sensor_EcInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensor_EcInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensor_ec(inputs)
});